import toast from "react-hot-toast";
import {AI_SERVER_URL} from "./constants";

const checkResponse = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    const shortErrorMessage = `Ошибка запроса: ${response.status}`;
    console.error(`Ошибка запроса: ${response.statusText} - ${errorText}`);
    toast.error(shortErrorMessage);
    throw new Error(`${response.statusText} - ${errorText}`);
  }
  return response.json();
};

export const getHello = async () => {
  try {
    const response = await fetch(`${AI_SERVER_URL}/api/hello`, {
      method: "GET",
    });
    const data = await checkResponse(response);
    return data;
  } catch (error) {
    console.error("Ошибка приветственного сообщения:", error);
    throw error;
  }
};

export const sendImageFile = async (formData) => {
  try {
    const response = await fetch(`${AI_SERVER_URL}/api/analyze`, {
      method: "POST",
      body: formData,
    });
    return await checkResponse(response);
  } catch (error) {
    console.error("Ошибка отправки файла:", error);
    throw error;
  }
};

export const sendImageTruck = async (formData) => {
  try {
    const response = await fetch(`${AI_SERVER_URL}/api/truck`, {
      method: "POST",
      body: formData,
    });
    return await checkResponse(response);
  } catch (error) {
    console.error("Ошибка отправки фото грузовика:", error);
    throw error;
  }
};

export const sendImageOffice = async (formData) => {
  try {
    const response = await fetch(`${AI_SERVER_URL}/api/rennis`, {
      method: "POST",
      body: formData,
    });
    return await checkResponse(response);
  } catch (error) {
    console.error("Ошибка отправки фото офиса:", error);
    throw error;
  }
};

export const sendImageRequest = async (base64Image, sender = "Отправитель", timestamp = new Date().toISOString()) => {
  const requestData = {
    photo: base64Image,
    sender,
    timestamp,
  };

  try {
    const response = await fetch(`${AI_SERVER_URL}/api/analyze`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData.content),
    });

    const data = await checkResponse(response);
    return data;
  } catch (error) {
    console.error("Ошибка отправки изображения:", error);
    throw error;
  }
};

/* // Имитация работы API
window.originalFetch = window.fetch;

window.fetch = async (url, options = {}) => {
  if (url.endsWith('/api/hello') && options.method === 'GET') {
    return new Response(
      JSON.stringify({
        message: `Привет, это тестовый ИИ-бот Cleansy! 
        Отправь мне фото помещения и я сделаю анализ чистоты, а так же помогу заказать клининг.`,
      }),
      {
        status: 200,
        headers: {'Content-Type': 'application/json'},
      }
    );
  }

  // Заглушка /api/analyze
  if (url.endsWith('/api/analyze') && options.method === 'POST') {
    return new Response(
      {
        'objects': ['чистый пол', 'помещение офиса', 'две мусорных корзины'],
        'presence_of_trash': 0,
        'surface_cleanliness': 3,
        'uniformity_of_cleaning': 4,
        'floor_cleaning_quality': 2,
        'dust_level_on_horizontal_surfaces': 1,
        'restroom_condition': 'Не выявлено',
        'trash_bin_fullness': 5,
        'presence_of_foreign_objects': 3,
        'adherence_to_sanitary_norms': 4,
        'recommendations': {
          'presence_of_trash': 'Сформировать заявку на уборку',
          'surface_cleanliness': 'Сформировать заявку на уборку',
          'floor_cleaning_quality': 'Сформировать заявку на уборку',
          'dust_level_on_horizontal_surfaces': 'Сформировать заявку на уборку',
          'presence_of_foreign_objects': 'Сформировать заявку на уборку',
        },
      },
      {
        status: 200,
        headers: {'Content-Type': 'application/json'},
      }
    );
  }

  // Для остальных запросов вызываем оригинальный fetch
  return window.originalFetch(url, options);
};
 */
